import { ALERT_GROUPS } from "../../../utils/alertCategories";
import { MascotLoadingOverlay } from "../../shared";
import AlertCategoryCard from "./AlertCategoryCard";

const GRID = "grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 xl:grid-cols-3 2xl:grid-cols-4";

// Hesaplanan grupta gösterilecek iskelet kart sayısı (grubun kategori sayısı)
const PENDING_CARD_COUNT = { devices: 5, firms: 2, orders: 1 };

/** Bölüm başlığı — literal büyük harf yerine cümle düzeni; CSS uppercase YOK */
function GroupHeading({ label, total }) {
  return (
    <div className="mb-2.5 flex items-center gap-2">
      <h2 className="text-sm font-SemiBold text-gray-700">{label}</h2>
      <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-Medium tabular-nums text-gray-500">
        {total ?? "…"}
      </span>
      <span aria-hidden="true" className="h-px flex-1 bg-gray-100" />
    </div>
  );
}

/**
 * Organizma: kategorileri gruplara ayırıp kart ızgarasında gösterir.
 * Yalnız kategorisi olan (izinli) gruplar çizilir; `pendingGroups` içindeki
 * (henüz hesaplanan, #238) gruplar başlığıyla birlikte iskelet olarak durur.
 */
export default function AlertCategoryGrid({ categories, onOpen, pendingGroups = [] }) {
  let cardIndex = 0;
  return (
    <div className="space-y-6">
      {ALERT_GROUPS.map((group) => {
        const items = categories.filter((c) => c.group === group.key);
        if (!items.length) {
          if (!pendingGroups.includes(group.key)) return null;
          return (
            <section key={group.key}>
              <GroupHeading label={group.label} />
              <GroupSkeleton
                count={PENDING_CARD_COUNT[group.key]}
                message={`${group.label} hesaplanıyor...`}
              />
            </section>
          );
        }
        const total = items.reduce((sum, c) => sum + c.count, 0);
        return (
          <section key={group.key}>
            <GroupHeading label={group.label} total={total} />
            <div className={GRID}>
              {items.map((category) => (
                <AlertCategoryCard
                  key={category.id}
                  category={category}
                  onOpen={onOpen}
                  index={cardIndex++}
                />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}

/** Grup iskeleti — kural gereği MascotLoadingOverlay iskeletin üstünde */
function GroupSkeleton({ count, message }) {
  return (
    <div className="relative">
      <MascotLoadingOverlay message={message} />
      <div className={GRID}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="h-[168px] rounded-2xl border border-gray-100 bg-gray-50 motion-safe:animate-pulse" />
        ))}
      </div>
    </div>
  );
}

/** Yükleme iskeleti — kural gereği MascotLoadingOverlay iskeletin üstünde */
export function AlertCategoryGridSkeleton({ count = 8 }) {
  return (
    <div className="relative">
      <MascotLoadingOverlay message="Uyarılar yükleniyor..." />
      <div className={GRID}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="h-[168px] rounded-2xl border border-gray-100 bg-gray-50 motion-safe:animate-pulse" />
        ))}
      </div>
    </div>
  );
}
